import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import auth from "../api/auth";
import kapi from "../api/kratos";
import dashboard_api from "../api/protected/dashboard";
import InfoRightPopUp from "../components/InfoRightPopUp";
import kratos_messages from "../models/KratosMessages";

const VerifyEmail = () => {
    const [message, setMessage] = useState("Verifying your email...");
    const [loading, setLoading] = useState(true)
    const [unverifiedMode, setUnverifiedMode] = useState(false)
    const navigate = useNavigate();
    const [flowResponse, setFlowResponse] = useState();
    const [email, setEmail] = useState("");
    const [userNeedsToInputEmail, setUserNeedsToInputEmail] = useState(false)

    const InitVerification = () => {
        const response = kapi.init_verification()
        response.then(response => {
            setFlowResponse(response.data);
        }).catch(() => {})
    }

    const IsEmailValid = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }

    const PageLoad = useCallback(() => {
        const params = new URLSearchParams(window.location.search);
        const flowId = params.get('flow');

        let u = JSON.parse(localStorage.getItem("user"))
        if (u && u.email && IsEmailValid(u.email)) {
            setUserNeedsToInputEmail(false)
            setEmail(u.email);
        }
        else {
            setUserNeedsToInputEmail(true)
        }

        if (!flowId) {
            InitVerification();
        }
        else {
            const response = kapi.get_verification(flowId);
            response.then(response => {
                setFlowResponse(response.data);
            }).catch(err => {
                console.log("Unable to retrieve verification flow: " + err);
            });
        }
    }, [])

    useEffect(() => {
        PageLoad()
    }, [PageLoad])


    useEffect(() => {
        const runVerification = async () => {
            const params = new URLSearchParams(window.location.search);
            const flowId = params.get("flow");
            const unverifiedLogin = params.get("unverified")

            if (!flowId && !unverifiedLogin) {
                // no flow param -> just go back to dashboard
                navigate("/dashboard");
                return;
            }

            if (!flowId && unverifiedLogin) {
                // Switch to "action required" mode
                setUnverifiedMode(true)
                setLoading(false)
                return
            }

            // 1. Check if user has a session
            const hasSession = await auth.hasSession();
            if (!hasSession) {
                // save flowId temporarily so we can retry after login
                localStorage.setItem("pendingVerifyFlow", flowId);
                navigate("/login");
                return;
            }
            
            try {
                // 2. Check if already verified
                const isVerified = await dashboard_api.getValidateEmail()
                if (isVerified.data === 1) {
                    setMessage("You have verified your email address.");
                }
                else {
                    // 3. Get verification flow from Kratos
                    const { data: flowData } = await kapi.get_verification(flowId);

                    // 4. Send flowData to backend through dashboard_api
                    const resp = await dashboard_api.putValidateEmail(flowData);

                    if (resp.data?.success) {
                        setMessage("Thanks for verifying your email!");
                    } else {
                        setMessage("Could not verify your email. Please try again.");
                    }
                }

            } catch (err) {
                if (err.response.data.description === "Flow not passed yet")
                    setMessage("Please check your email for a verification email.");
                else {
                    console.error("Verification failed:", err);
                    setMessage("Verification failed or expired. Please request a new link.");
                }
            } finally {
                setLoading(false);
            }
        };

        runVerification();
    }, [navigate]);

    return (
        <div className="verify-email-page-background-container">
            <div className="verify-email-page-container">
                <div className="verify-email-page-header">
                    <div className="page-header-title-container">
                        <div className="verify-email-page-title">
                            {unverifiedMode ? "Action Required: Email Verification" : "Verify Email"}
                        </div>
                        <InfoRightPopUp text={"This page provides information about the email verification process."}/>
                    </div>
                </div>
                <div className="verify-email-page-container">
                    {loading ? (
                        <p>Checking verification...</p>
                    ) : (
                        <>
                            <p className="verify-email-message">
                                {unverifiedMode
                                    ? "Please click the link in your email to verify your email address and get access to the platform."
                                    : message}
                            </p>

                            <p className="verify-email-message">
                                Not received an email or has the email expired?
                            </p>

                            <form action={flowResponse && flowResponse.ui.action} method="POST">
                                <div>
                                    {flowResponse && flowResponse?.ui?.messages?.map((msg) => {
                                        return(
                                            <div className="messages">{kratos_messages.getMessage(msg.id, msg.text)}</div>
                                        )
                                    })}
                                </div>

                                <input name="csrf_token" type="hidden" value={flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'csrf_token')?.attributes.value}/>

                                <div className="row">
                                    <div className="col-sm-12">
                                        {userNeedsToInputEmail ?
                                            <input className="login-input" name="email" type="email" value={email} onChange={(ev) => setEmail(ev.target.value)} placeholder="E-Mail" required/>
                                            :
                                            <input name="email" type="hidden" value={email} required/>
                                        }
                                        <div>{flowResponse && flowResponse.ui.nodes.find(n => n.attributes.name === 'email')?.messages.map((msg) => {
                                            return (
                                                <div className="messages">{kratos_messages.getMessage(msg.id, msg.text)}</div>
                                            )})}
                                        </div>
                                    </div>
                                </div>
                                <div className="verify-email-button-row">
                                    <button className="register-button link" name="method" type="submit" value="link">
                                        Resend Email
                                    </button>

                                    <button type="button" className="dashboard-tasks-create-task-button bold" onClick={() => navigate("/dashboard")}>
                                        Go to Dashboard
                                    </button>
                                </div>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
